// src/components/ContactUs.js
import React, { useState } from 'react';
import './ContactUs.css';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear individual field error on change
    setErrors({ ...errors, [e.target.name]: '' });
    setSubmitMessage('');
  };

  // Validate inputs
  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email.";
    }
    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required.";
    }
    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters long.";
    }
    return newErrors;
  };

  // Handle form submission with backend integration and disable button while sending
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    
    setIsSending(true);
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      const data = await response.json();
      if (response.ok) {
        setSubmitMessage(data.message);
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
        setErrors({});
      } else {
        setSubmitMessage(data.error || 'An error occurred.');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setSubmitMessage('An error occurred while sending your message.');
    }
    
    setIsSending(false);
  };

  return (
    <section className="contact-us-page">
      <div className="contact-container">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you! Please fill out the form below and we'll get back to you shortly.</p>
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="name">Name<span className="required">*</span></label>
            <input 
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? 'error' : ''}
              placeholder="Your Name"
            />
            {errors.name && <small className="error-message">{errors.name}</small>}
          </div>

          <div className="form-group">
            <label htmlFor="email">Email<span className="required">*</span></label>
            <input 
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error' : ''}
              placeholder="you@example.com"
            />
            {errors.email && <small className="error-message">{errors.email}</small>}
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject<span className="required">*</span></label>
            <input 
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className={errors.subject ? 'error' : ''}
              placeholder="Subject"
            />
            {errors.subject && <small className="error-message">{errors.subject}</small>}
          </div>

          <div className="form-group">
            <label htmlFor="message">Message<span className="required">*</span></label>
            <textarea 
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className={errors.message ? 'error' : ''}
              placeholder="Your Message"
              rows="5"
            />
            {errors.message && <small className="error-message">{errors.message}</small>}
          </div>

          <button type="submit" className="submit-button" disabled={isSending}>
            {isSending ? 'Sending...' : 'Send Message'}
          </button>
          {submitMessage && <p className="submit-message">{submitMessage}</p>}
        </form>
      </div>
    </section>
  );
}

export default ContactUs;
